import { ChildSubUser } from "../Models/ChildSubUser";
import * as ko from "knockout";

export class LoginViewModel {
    showImpersonation = ko.observable<boolean>(false);
    showPasswordFeedback = ko.observable<boolean>(false);
    showDeactivatedFeedback = ko.observable<boolean>(false);
    childSubUsers = ko.observableArray<ChildSubUser>(null);
}